// Featured products / resources on the homepage.
// Add new entries here — UI adapts automatically (hero layout for 1 item, grid for 2+).
export const featuredProducts = [
    {
        id: "guide-jeunes-heros-7-10",
        name: "Le Guide Complet des Jeunes Héros",
        nameAccent: "Jeunes Héros",
        eyebrow: "Guide PDF · 7-10 ans",
        description:
            "Aidez votre enfant à développer sa confiance, gérer ses émotions et apprendre plus efficacement grâce aux neurosciences.",
        cover: "/guide-jeunes-heros-cover.jpg",
        price: "17€",
        oldPrice: "27€",
        discountLabel: "-37%",
        priceCaption: "Prix spécial lancement",
        badge: "Offre de lancement",
        tag: "Nouveau",
        cta: { label: "Obtenir le Guide", url: "https://payhip.com/b/gh2o0" },
        benefits: [
            "Développer la confiance en soi",
            "Apprendre à gérer ses émotions",
            "Mémoriser plus efficacement",
            "Cultiver la persévérance",
        ],
    },
];
